import { FC, useEffect, useRef, useState } from 'react';
import { Card, Box, Grid, Stack, Typography, Modal } from '@mui/material';
import Container from '@mui/material/Container';
import "../../index.css"
import { Link as RouterLink } from 'react-router-dom';
import SigninForm from './SigninForm';
import HomeHeader from './HomeHeader';
// import loginImage from '../.././login-image.png';

import BgImg0 from './images/bg-registration-form-2.jpg';
import BgImg from './images/header/banner-bg.svg';
import BgImg2 from './images/bg2.png';
import Img0 from './images/icon.png';
import Img1 from './images/wareozo-light.png';
import Img01 from './images/wareozo.png';
import Img2 from './images/header/header-hero.png';
import Img3 from './images/brands/uideck.svg';
import Img4 from './images/brands/ayroui.svg';
import Img5 from './images/brands/graygrids.svg';
import Img6 from './images/brands/lineicons.svg';
import Img7 from './images/brands/ecommerce-html.svg';
import Img8 from './images/services/services-shape.svg';
import Img9 from './images/services/services-shape-1.svg';
import Img10 from './images/services/services-shape-2.svg';
import Img11 from './images/services/services-shape-3.svg';
import Img12 from './images/about/about1.svg';
import Img13 from './images/about/about-shape-1.svg';
import Img14 from './images/about/about-shape-2.svg';
import Img15 from './images/about/about2.svg';
import Img16 from './images/about/about3.svg';
import Img17 from './images/video/video.png';
import Img18 from './images/video/dots.svg';
// import { Helmet } from "react-helmet";
import SignUpForm from '../SignUp/SignUpForm';
import ForgotPassword from '../ForgotPassword/ForgotPassword';


/**
 * Sign In form Component. 
 */
// export function AddLibrary(urlOfTheLibrary:string) {
//   const script = document.createElement("script");
//   script.src = urlOfTheLibrary;
//   script.async = true;
//   document.body.appendChild(script);
// }



const PrivacyPolicy: FC = () => {

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const [type, setType] = useState('0');

  const navRef = useRef<any>()

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  
  useEffect(() => {
    import('./css/animate.css');
    import('./css/glightbox.min.css');
    import('./css/lineicons.css');
    import('./css/bootstrap.min.css');
    import('./css/style.css');
    import('./css2/style.css');
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const { offsetTop } = navRef.current
      if (window.pageYOffset > offsetTop) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const isMobile = width <= 768;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1200);
  }, [])
  return (
    <>

      {loading && <div className="preloader">
        <div className="loader">
          <div className="spinner">
            <div className="spinner-container">
              <div className="spinner-rotator">
                <div className="spinner-left">
                  <div className="spinner-circle"></div>
                </div>
                <div className="spinner-right">
                  <div className="spinner-circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}

      <header className="header-area" style={{marginTop: '-64px'}}>
        <div ref={navRef} className={`navbar-area ${scrolled && 'sticky'}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav className="navbar navbar-expand-lg">
                  <a className="navbar-brand" href="/signin">
                    <img src={Img0} alt="Logo" style={{ width: isMobile ? scrolled ? 40 : 60 : scrolled ? 50 : 80 }} />
                    <img src={scrolled ? Img01 : Img1} alt="Logo" style={{ width: isMobile ? scrolled ? 80 : 120 : scrolled ? 120 : 150 }} />
                  </a>
                  <button
                    className={`navbar-toggler ${menu && 'active'}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={() => setMenu(!menu)}
                  >
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                  </button>

                  <div
                    className={`collapse navbar-collapse sub-menu-bar ${menu && 'show'}`}
                    id="navbarSupportedContent"
                  >
                    <ul id="nav" className="navbar-nav ms-auto">
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#home">Home</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#features">Features</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#pricing">Pricing</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#about">About</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#facts">Why</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a href="/signin#faq">FAQ</a>
                      </li>
                    </ul>
                  </div>

                  <div className="navbar-btn d-none d-sm-inline-block">
                    <a
                      className="main-btn"
                      style={{ backgroundColor: scrolled ? '#059669' : '#fff', color: scrolled ? '#fff' : '#059669', border: '2px solid #059669', textDecoration: 'none' }}
                      data-scroll-nav="0"
                      onClick={() => setOpen(!open)}
                      // href="https://uideck.com/templates/basic/"
                      rel="nofollow"
                    >
                      Login Now
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div
          id="home"
          className="header-hero bg_cover"
          style={{ backgroundImage: `url(${BgImg})` }}

        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="header-hero-content text-center">
                  {/* <h3
                    className="header-sub-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.2s"
                  >
                    Basic - SaaS Landing Page
                  </h3> */}
                  <h2
                    className="header-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.5s"
                  >
                    Privacy & Policy
                  </h2>
                  {/* <p
                    className="text wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.8s"
                  >
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor
                  </p>
                  <a
                    href="javascript:void(0)"
                    onClick={() => setOpen(!open)}
                    className="main-btn wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="1.1s"
                  >
                    Get Started
                  </a> */}
                </div>
              </div>
            </div>
            <div style={{ height: 300 }}>

            </div>
          </div>
          <div id="particles-1" className="particles"></div>
        </div>

      </header>

      <section>
        <div style={{padding: '0 10%'}}>

          <p style={{marginTop: '20px'}}>
            <strong>Effective Date:</strong> 01 January 2024<br />
            <strong>Last Updated:</strong> 31 March 2026
          </p>

          <h2 style={{marginTop: '20px', marginBottom: '10px', fontSize: '22px'}}>1. Introduction</h2>
          <p>
            Welcome to <strong>Wareozo</strong>, a product of <strong>Purvish Infotech</strong> ("Company", "we", "our", "us").
            We value your privacy and are committed to protecting your personal information.
          </p>
          <p>
            This Privacy Policy explains how we collect, use, store, and protect your information when you use our billing software, website, mobile/web application, and communication services, including our integration with Meta's WhatsApp Business Platform.
          </p>
          <p>
            By using Wareozo, you agree to the collection and use of information in accordance with this Privacy Policy.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>2. Scope of This Policy</h2>
          <p>
            This Privacy Policy applies to all users who access or use the Wareozo platform, including:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Business owners and their employees who use Wareozo to manage billing, invoicing, and customer communication</li>
            <li>End-customers of businesses who receive communications (including WhatsApp messages) sent via Wareozo</li>
            <li>Visitors to the Wareozo website</li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>3. Information We Collect</h2>
          <p>
            We may collect the following categories of information:
          </p>

          <div style={{paddingLeft: '24px'}}>
            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>3.1 Personal Information</h3>
            <p>
              Information you provide directly to us, including:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Full name</li>
              <li>Phone number</li>
              <li>Email address</li>
              <li>Business name</li>
              <li>Business address</li>
              <li>GST / tax-related business details (if applicable)</li>
            </ul>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>3.2 Billing and Transaction Information</h3>
            <p>
              To provide billing and invoicing services, we may collect:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Customer details</li>
              <li>Invoice and billing records</li>
              <li>Payment-related records</li>
              <li>Product / service transaction details</li>
              <li>Purchase and sales information</li>
            </ul>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>3.3 WhatsApp Communication Data</h3>
            <p>
              When our platform sends or manages WhatsApp messages using the WhatsApp Business API, we may process:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Phone numbers used for messaging</li>
              <li>Message delivery status</li>
              <li>Message templates used</li>
              <li>Message timestamps</li>
              <li>Conversation logs or message metadata</li>
              <li>Customer support communication records</li>
            </ul>
            <p>
              <strong>Important:</strong> We use WhatsApp communication data only for business communication, transactional notifications, customer engagement, and support purposes.
            </p>
            <p>
              WhatsApp communication data will <strong>not</strong> be used for advertising, profiling, retargeting, cross-selling, data brokering, or any purpose beyond the specific business communication for which it was originally collected. Data obtained through WhatsApp is used only to support the messaging interaction for which it was provided — it is <strong>not</strong> combined with other data sets for marketing, analytical, or advertising purposes. We do not sell, license, or share WhatsApp data with any third party for their own marketing or advertising use.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>3.4 Device and Usage Information</h3>
            <p>
              We may automatically collect technical data such as:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Device type</li>
              <li>Operating system</li>
              <li>Login activity</li>
              <li>Access timestamps</li>
              <li>Usage behavior within the application</li>
            </ul>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>3.5 Cookies and Tracking Technologies</h3>
            <p>
              We may use cookies, local storage, and similar tracking technologies to:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Maintain user sessions and authentication state</li>
              <li>Remember user preferences and settings</li>
              <li>Analyze usage patterns to improve our services</li>
              <li>Ensure platform security</li>
            </ul>
            <p>
              You can control cookie preferences through your browser settings. Disabling certain cookies may affect the functionality of the platform.
            </p>
          </div>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>4. How We Use Your Information</h2>
          <p>
            We use the information we collect for the following purposes:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>To provide and operate our billing and business management services</li>
            <li>To create, manage, and store invoices and transaction records</li>
            <li>To send billing alerts, reminders, invoices, receipts, and transactional updates</li>
            <li>To send approved business communications via WhatsApp</li>
            <li>To improve platform performance, reliability, and user experience</li>
            <li>To maintain security and prevent fraud, abuse, or unauthorized access</li>
            <li>To provide customer support and resolve issues</li>
            <li>To comply with legal, tax, accounting, and regulatory obligations</li>
          </ul>
          <p>
            Promotional or marketing messages are sent <strong>only to users who have explicitly opted in</strong>.
          </p>
          <p>
            We do not sell or rent your personal data to third parties.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>5. WhatsApp Business API Usage</h2>
          <p>
            Wareozo integrates with Meta's WhatsApp Business Platform to enable businesses to send communications such as:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Invoice notifications</li>
            <li>Payment reminders</li>
            <li>Order confirmations</li>
            <li>Billing alerts</li>
            <li>Customer support messages</li>
            <li>Business-related updates</li>
          </ul>
          <p>
            We comply with all applicable Meta and WhatsApp Business Platform policies and use messaging features only for legitimate business communication.
          </p>

          <div style={{paddingLeft: '24px'}}>
            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.1 Opt-In Requirement</h3>
            <p>
              Wareozo and any business using its platform may only send WhatsApp messages to customers who have:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Voluntarily provided their mobile phone number, AND</li>
              <li>Given explicit opt-in permission to receive WhatsApp communications from that business.</li>
            </ul>
            <p>
              Opt-in must be obtained clearly and separately for different message categories (e.g., billing alerts, appointment reminders, promotional offers). Wareozo provides an <a href="/opt-in" style={{color: '#059669'}}>Opt-In form</a> to assist with consent collection. The business is solely responsible for determining the method of opt-in and ensuring it complies with all applicable laws.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.2 Message Frequency</h3>
            <p>
              The frequency of WhatsApp messages sent to end-customers depends on the nature of the business communication and the preferences set by the business using Wareozo. Message types and their typical frequency include:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li><strong>Transactional messages</strong> (invoices, receipts, payment confirmations): Sent as triggered by business events</li>
              <li><strong>Reminders</strong> (payment due, appointment): Sent based on scheduled events</li>
              <li><strong>Promotional messages</strong>: Sent only with explicit opt-in, and businesses must respect reasonable frequency limits</li>
            </ul>
            <p>
              Users may adjust their messaging preferences or opt out at any time via our <a href="/opt-out" style={{color: '#059669'}}>Opt-Out page</a> or by replying STOP to any WhatsApp message.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.3 Platform vs. Business Responsibility</h3>
            <p>
              Wareozo acts as a technology platform and service provider. The business (our client) using Wareozo to send WhatsApp messages to their end-customers is solely responsible for:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Obtaining valid, documented opt-in consent from their customers before messaging them.</li>
              <li>Ensuring that opt-in is collected in a manner compliant with applicable laws (including the Information Technology Act, 2000, PDPB, TRAI regulations, and any applicable GDPR or foreign data laws).</li>
              <li>Maintaining records of consent obtained.</li>
              <li>Honoring all opt-out requests from their customers promptly.</li>
            </ul>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.4 Approved Message Templates</h3>
            <p>
              All outbound WhatsApp messages initiated by Wareozo or businesses using the platform are based on Meta-approved Message Templates. These templates are reviewed and approved by Meta before use and are only used for their designated communication purpose. No template is used outside its approved intent.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.5 Automation and Human Escalation</h3>
            <p>
              Where automated WhatsApp responses are used within the platform (e.g., auto-replies, chatbot flows), the following human escalation paths are always available to customers:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>In-chat transfer to a human support agent</li>
              <li>Email: <a href="mailto:support@wareozo.com">support@wareozo.com</a></li>
              <li>In-app support feature</li>
              <li>Business contact details maintained in the WhatsApp Business Profile</li>
            </ul>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.6 Prohibition on Sensitive Data via WhatsApp</h3>
            <p>
              Wareozo and its clients must not request or transmit the following through WhatsApp communications:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Full payment card numbers or CVV codes</li>
              <li>Bank account or financial institution numbers</li>
              <li>National ID card, Aadhaar, PAN, or similar personal identification numbers</li>
              <li>Passwords, OTPs, or authentication credentials</li>
              <li>Any other sensitive personal identifiers</li>
            </ul>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.7 Data Shared with Meta</h3>
            <p>
              As part of our integration with the WhatsApp Business Platform, the following data may be transmitted to or processed by Meta Platforms, Inc.:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Recipient phone numbers for message delivery</li>
              <li>Message template content and parameters</li>
              <li>Message delivery and read status</li>
              <li>Media files attached to messages (if applicable)</li>
            </ul>
            <p>
              This data is shared solely for the purpose of delivering WhatsApp messages and is governed by Meta's WhatsApp Business Platform terms and data processing policies. We do not authorize Meta to use this data for advertising purposes beyond what is stated in Meta's own policies.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.8 WhatsApp Data Retention</h3>
            <p>
              WhatsApp message metadata (delivery status, timestamps, phone numbers) is retained for a maximum of <strong>90 days</strong> from the date of the message, unless a longer retention period is required by law or for legitimate business purposes (e.g., dispute resolution). Message content stored on our platform is retained only for the duration necessary to fulfill the communication purpose and is deleted or anonymized thereafter.
            </p>
            <p>
              Businesses using Wareozo may configure their own data retention settings within the platform, subject to applicable legal requirements.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>5.9 Healthcare and Telemedicine Restrictions</h3>
            <p>
              Wareozo does not use WhatsApp communications for telemedicine consultations or to transmit individually identifiable health records or clinical data. WhatsApp is used solely for transactional and operational notifications — such as appointment reminders, billing alerts, and general business updates — that do not constitute healthcare service delivery. Businesses in the healthcare sector using Wareozo must ensure their use of WhatsApp communication complies with all applicable health data regulations.
            </p>
          </div>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>6. Legal Basis / Consent</h2>
          <p>
            Where required by applicable law, we process personal data based on one or more of the following:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Your consent</li>
            <li>Performance of a contract or service</li>
            <li>Legal or regulatory obligations</li>
            <li>Legitimate business interests such as billing operations, fraud prevention, and customer communication</li>
          </ul>
          <p>
            Users and businesses using Wareozo are responsible for ensuring they have appropriate consent or lawful basis before messaging their customers using WhatsApp or other communication channels.
          </p>
          <p>
            <strong>Opt-Out:</strong> Users may opt out of WhatsApp, Email, or SMS communications at any time by:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Visiting our <a href="/opt-out" style={{color: '#059669'}}>Opt-Out page</a></li>
            <li>Replying <strong>"STOP"</strong> to any WhatsApp message</li>
            <li>Contacting our support team at <a href="mailto:support@wareozo.com">support@wareozo.com</a></li>
          </ul>
          <p>
            Opt-out requests received through any channel will be honored promptly and the relevant phone number or email removed from all active communication lists. Businesses using Wareozo must ensure these opt-out mechanisms are respected for all their customers.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>7. Data Sharing</h2>
          <p>
            We do not sell your personal data.
          </p>
          <p>
            We may share your data only in the following situations:
          </p>

          <div style={{paddingLeft: '24px'}}>
            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>7.1 Service Providers</h3>
            <p>
              We may share information with trusted third-party service providers that help us operate our services, such as:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Meta / WhatsApp Business Platform</li>
              <li>Cloud hosting providers</li>
              <li>Email or notification providers</li>
              <li>Payment or infrastructure partners</li>
              <li>Analytics and monitoring providers</li>
            </ul>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>7.2 Legal Compliance</h3>
            <p>
              We may disclose data if required to:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Comply with applicable laws or legal processes</li>
              <li>Respond to lawful requests by authorities</li>
              <li>Protect our legal rights, users, or platform security</li>
            </ul>
            <p>
              All third parties comply with applicable data protection laws.
            </p>
          </div>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>8. Data Retention</h2>
          <p>
            We retain personal and business data only as long as necessary to:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Provide our services</li>
            <li>Maintain billing and transaction records</li>
            <li>Comply with legal, tax, accounting, and regulatory requirements</li>
            <li>Resolve disputes and enforce agreements</li>
          </ul>
          <p>
            Retention periods may vary depending on the nature of the data and applicable legal obligations.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>9. Data Security</h2>
          <p>
            We take reasonable technical and organizational measures to protect your data, including:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>All data is securely stored in our system</li>
            <li>Secure access controls</li>
            <li>Authentication and authorization measures</li>
            <li>Encrypted transmission where applicable</li>
            <li>Protected servers and infrastructure</li>
            <li>Monitoring for suspicious or unauthorized activity</li>
          </ul>
          <p>
            While we take appropriate precautions, no method of transmission or storage is 100% secure. Therefore, we cannot guarantee absolute security.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>10. Data Breach Notification</h2>
          <p>
            In the event of a data breach that affects your personal information, we will:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Notify affected users without undue delay, and within 72 hours where feasible</li>
            <li>Inform relevant regulatory authorities as required by applicable law</li>
            <li>Take immediate steps to contain the breach and minimize potential harm</li>
            <li>Provide details about the nature of the breach, the data affected, and recommended protective measures</li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>11. User Rights</h2>
          <p>
            Depending on applicable laws, users may have the right to:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Request access to their personal data</li>
            <li>Request correction of inaccurate or incomplete information</li>
            <li>Request deletion of personal data</li>
            <li>Object to or restrict certain processing</li>
            <li>Withdraw consent where consent is the basis of processing</li>
            <li>Opt out of communications via our <a href="/opt-out" style={{color: '#059669'}}>Opt-Out page</a></li>
          </ul>
          <p>
            To exercise these rights, contact us at: <strong><a href="mailto:support@wareozo.com">support@wareozo.com</a></strong> or use our <a href="/opt-out" style={{color: '#059669'}}>Opt-Out page</a> for communication preferences.
          </p>
          <p>
            We may request identity verification before processing certain requests.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>12. Automated Decision-Making</h2>
          <p>
            Wareozo does not use personal data obtained through WhatsApp or other communication channels for automated decision-making or profiling that produces legal effects or similarly significant effects on individuals. Any automated features within the platform (e.g., automated invoice reminders, payment follow-ups) are operational in nature and do not involve profiling or scoring of individuals.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>13. Third-Party Services</h2>
          <p>
            Our services may integrate with or rely on third-party platforms, including Meta / WhatsApp.
          </p>
          <p>
            Use of those services may also be subject to their own privacy policies and terms. We encourage users to review the privacy policies of relevant third-party platforms where applicable.
          </p>
          <p>
            WhatsApp Business Platform is operated by Meta Platforms, Inc. Clients and end-users interacting with businesses through Wareozo's WhatsApp integration are also subject to Meta's applicable terms and policies, including:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>WhatsApp Business Terms of Service: <a href="https://www.whatsapp.com/legal/business-terms" target="_blank" rel="noopener noreferrer">https://www.whatsapp.com/legal/business-terms</a></li>
            <li>WhatsApp Business Messaging Policy: <a href="https://business.whatsapp.com/policy" target="_blank" rel="noopener noreferrer">https://business.whatsapp.com/policy</a></li>
            <li>WhatsApp Messaging Guidelines: <a href="https://www.whatsapp.com/legal/messaging-guidelines" target="_blank" rel="noopener noreferrer">https://www.whatsapp.com/legal/messaging-guidelines</a></li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>14. Children's Privacy</h2>
          <p>
            Wareozo is intended for business and commercial use and is not directed to children under the age of 13 (or the minimum age required by applicable law).
          </p>
          <p>
            We do not knowingly collect personal information from children.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>15. International Data Processing</h2>
          <p>
            Depending on our infrastructure or third-party providers, your data may be processed or stored in locations outside your immediate jurisdiction.
          </p>
          <p>
            Where applicable, we take reasonable steps to ensure such data transfers are handled securely and in accordance with applicable laws.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>16. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time.
          </p>
          <p>
            When significant changes are made, we may notify users through the application, website, email, or other appropriate channels. The updated version will always include the latest "Last Updated" date.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>17. Company Information</h2>
          <p>
            <strong>Purvish Infotech</strong><br />
            Website: <a href="https://purvishinfotech.com" target="_blank" rel="noopener noreferrer">https://purvishinfotech.com</a><br />
            Product: <a href="https://wareozo.com" target="_blank" rel="noopener noreferrer">https://wareozo.com</a><br />
            Email: <a href="mailto:support@wareozo.com">support@wareozo.com</a>
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>18. Grievance Officer</h2>
          <p>
            In accordance with the Information Technology Act, 2000 and the rules made thereunder, the name and contact details of the Grievance Officer are provided below:
          </p>
          <p>
            <strong>Grievance Officer:</strong> Vishakha Bitle<br />
            <strong>Email:</strong> <a href="mailto:vishakha@purvishinfotech.com">vishakha@purvishinfotech.com</a><br />
            <strong>Address:</strong> 121, Sai Nagar, Near HBL Tower, Nagpur, Maharashtra - 441108
          </p>
          <p>
            If you have any complaints regarding the processing of your personal data, you may contact the Grievance Officer. We will acknowledge your complaint within 24 hours and aim to resolve it within 30 days from the date of receipt.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>19. Contact Us</h2>
          <p>
            If you have any questions, requests, or concerns about this Privacy Policy or our data practices, please contact us:
          </p>
          <p>
            <strong>Wareozo</strong><br />
            Email: <strong><a href="mailto:support@wareozo.com">support@wareozo.com</a></strong><br />
            Website: <a href="https://wareozo.com" target="_blank" rel="noopener noreferrer">https://wareozo.com</a>
          </p>

        </div>
      </section>

      <footer id="footer" className="footer-area pt-120">
        <div className="container">
          <div
            className="subscribe-area wow fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.5s"
          >
            <div className="row align-items-center">
              <div className="col-lg-8">
                <div className="subscribe-content mt-45">
                  <h2 className="subscribe-title">
                    Stay Connected <span>subscribe to our communication channels</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mt-45" style={{ textAlign: 'right' }}>
                  <a href="/opt-in" style={{ textDecoration: 'none', padding: '12px 36px', borderRadius: '30px', backgroundColor: '#059669', color: '#fff', fontSize: '16px', fontWeight: 600, display: 'inline-block' }}>Subscribe Now</a>
                </div>
              </div>
            </div>

          </div>
          <div className="footer-widget pb-100">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-8">
                <div
                  className="footer-about mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.2s"
                >
                  <a className="logo" href="javascript:void(0)">
                    <img src={Img0} alt="Wareozo" style={{ width: 80 }} />
                    <img src={Img1} alt="Wareozo" />
                  </a>
                  <p className="text">
                    Simplify invoicing, automate accounting, and boost business growth with smart, secure, and efficient wareozo billing software. 
                  </p>
                  <ul className="social">
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-facebook-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-twitter-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-instagram-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-linkedin-original"> </i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5 col-md-7 col-sm-12">
                <div className="footer-link d-flex mt-50 justify-content-sm-between">
                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.4s"
                  >
                    <div className="footer-title">
                      <h4 className="title">Quick Link</h4>
                    </div>
                    <ul className="link">
                      <li><a href="/privacy-policy">Privacy Policy</a></li>
                      <li><a href="/terms-of-use">Terms of Service</a></li>
                      <li><a href="/signin#pricing">Pricing</a></li>
                      <li><a href="/signin#faq">FAQ</a></li>
                      <li><a href="/opt-out">Unsubscribe</a></li>
                    </ul>
                  </div>

                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.6s"
                  >
                    <div className="footer-title">
                      <h4 className="title">Resources</h4>
                    </div>
                    <ul className="link">
                      <li><a href="/signin#home">Home</a></li>
                      <li><a href="/signin#features">Features</a></li>
                      <li><a href="/signin#about">About</a></li>
                      <li><a href="/signin#why">Why</a></li>
                    </ul>
                  </div>

                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12">
                <div
                  className="footer-contact mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.8s"
                >
                  <div className="footer-title">
                    <h4 className="title">Contact Us</h4>
                  </div>
                  <ul className="contact">
                    <li>support@wareozo.com</li>
                    <li>www.wareozo.com</li>
                    <li>
                      121, Sai Nagar, Near HBL Tower, <br /> Nagpur, Maharashtra - 441108 
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
          <div className="footer-copyright">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright d-sm-flex justify-content-between">
                  <div className="copyright-content">
                    <p className="text">
                      Designed and Developed by 
                      <a href="javascript:void(0)" rel="nofollow"> &nbsp; Wareozo</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div id="particles-2"></div>
      </footer>

      <a href="#" className="back-to-top"> <i className="lni lni-chevron-up"> </i> </a>

      <Modal open={open} onClose={(event: any, reason: any) => {
        if (reason && reason == "backdropClick" && "escapeKeyDown")
          setOpen(false);
      }}>
        <div className='centerme'>
          <div className={`${isMobile ? 'maindiv2' : 'maindiv'}`}>
            <div style={{ width: isMobile ? '100%' : '50%' }}>
              {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType} /> : <ForgotPassword setType={setType} />}
            </div>
            {!isMobile && <div style={{ width: '50%' }}>
              <img src={BgImg2} />
            </div>}
          </div>

          {/* <div style={{backgroundImage: `url(${BgImg0})`, padding: 20,paddingTop:40, paddingBottom:40, width:'100%', height:'auto',margin:'auto',display:'flex',flexDirection:'row'}}>
            {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType}/> : <ForgotPassword setType={setType}/>}
            </div> */}

        </div>
      </Modal>

      {/* <Helmet>
      <script src="js/bootstrap.bundle.min.js" type="text/javascript"></script>
    <script src="js/wow.min.js" type="text/javascript"></script>
    <script src="js/glightbox.min.js" type="text/javascript"></script>
    <script src="js/count-up.min.js" type="text/javascript"></script>
    <script src="js/particles.min.js" type="text/javascript"></script>
    <script src="js/main.js" type="text/javascript"></script>
      </Helmet> */}

      {/* {AddLibrary("./js/bootstrap.bundle.min.js")}
      {AddLibrary("./js/wow.min.js")}
      {AddLibrary("./js/glightbox.min.js")}
      {AddLibrary("./js/count-up.min.js")}
      {AddLibrary("./js/particles.min.js")}
      {AddLibrary("./js/main.js")} */}
    </>
  );
}

export default PrivacyPolicy;

